var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"webFooter"},[_c('div',{staticClass:"recode"},[_vm._v(" Copyright © 2024 中国中铁股份有限公司 版权所有 Powered by 中铁信科 ")])])
}]

export { render, staticRenderFns }